import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { Router } from '@angular/router'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, FeatureType, Grid, ModalSize, SwpppSite } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { SwpppSiteWizardComponent } from './swppp-site-wizard.component'

@Component({
    selector: 'app-swppp-sites',
    templateUrl: './swppp-sites.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class SwpppSitesComponent extends BaseComponent {
    grid: Grid<SwpppSite>
    statusFilter: 'active' | 'inactive' | 'all' = 'active'
    private allSites: SwpppSite[] = []

    constructor(private router: Router) {
        super()
        this.grid = new Grid<SwpppSite>(this.services).filterBy(item => [item.name, item.job, item.address])
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            'swpppSites',
            true,
            this.services.data.load(true, true, this.services.data.swpppSites.queryAll()).subscribe({
                next: result => {
                    this.allSites = result[0]
                    this.applyFilter()
                    this.initialLoadingComplete()
                },
            }),
        )
    }

    applyFilter() {
        this.grid.items = this.allSites.filter(site => {
            if (this.statusFilter === 'active') return site.isActive
            if (this.statusFilter === 'inactive') return !site.isActive
            return true
        })
    }

    addSite() {
        const ref = this.services.modals.open(SwpppSiteWizardComponent, ModalSize.full95Percent)
        ref.result.then(
            (site: SwpppSite) => {
                if (site?.id) this.router.navigate(['/field-tools/swppp/site', site.id])
            },
            () => undefined,
        )
    }

    openSite(site: SwpppSite) {
        this.router.navigate(['/field-tools/swppp/site', site.id])
    }

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.FieldToolsSwpppEdit])
    }
}
